<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="bottom-right" key="br" />

  <header>
    <div class="headline">
      <h1>{{ headerTitle() }}</h1>
      @if (account(); as current) {
        <p-tag
          [severity]="current.accounting.isActive ? 'success' : 'secondary'"
          [value]="current.accounting.isActive ? ('EmployeeAccount_Active' | translateWF: 'Active') : ('EmployeeAccount_Inactive' | translateWF: 'Inactive')"
        />
      }
    </div>
    <div class="buttons">
      @if (canEdit) {
        <p-splitbutton [label]="'Save' | translateWF: 'Save'" (onClick)="save(false)" [model]="saveMenuItems" />
      }
      <p-button variant="outlined" (onClick)="back()">{{ 'Back' | translateWF: 'Back' }}</p-button>
    </div>
  </header>

  <p-breadcrumb class="max-w-full" [model]="menuItems()">
    <ng-template #item let-item>
      @if (item.route) {
        <a [routerLink]="item.route" class="p-breadcrumb-item-link">
          <span [ngClass]="[item.icon ? item.icon : '', 'text-color']"></span>
          <span class="text-primary">{{ item.label }}</span>
        </a>
      } @else {
        <a class="p-breadcrumb-current-item-link">
          <span class="text-color">{{ item.label }}</span>
        </a>
      }
    </ng-template>
  </p-breadcrumb>

  <div class="content">
    <!-- Rendered only once the employee is loaded: app-financial-account-select reads its read-only state once, on init. -->
    @if (account(); as current) {
      <div class="grid grid-cols-12 gap-5">
        <div class="col-span-12 xl:col-span-5">
          <p-panel [header]="'EmployeeAccount_Section_Employee' | translateWF: 'Employee'">
            <div class="grid grid-cols-2 gap-4">
              <div class="form-box">
                <label>{{ 'EmployeeAccount_Col_Code' | translateWF: 'Code' }}</label>
                <span class="font-mono">{{ current.employeeCode }}</span>
              </div>
              <div class="form-box">
                <label>{{ 'EmployeeAccount_Col_Name' | translateWF: 'Name' }}</label>
                <span>{{ current.name }}</span>
              </div>
              <div class="form-box">
                <label>{{ 'EmployeeAccount_Col_User' | translateWF: 'Nexus user' }}</label>
                <span>{{ current.username ?? ('EmployeeAccount_NoUser' | translateWF: 'No Nexus access') }}</span>
              </div>
              <div class="form-box">
                <label>{{ 'EmployeeAccount_EnabledBy' | translateWF: 'Enabled by' }}</label>
                <span>{{ current.accounting.enabledBy }} · {{ current.accounting.enabledDate | date: 'mediumDate' }}</span>
              </div>
            </div>
            <small class="block mt-4 text-surface-500">
              {{ 'EmployeeAccount_Section_Employee_Hint' | translateWF: 'A Standard employee, named after its Nexus user when it was created.' }}
            </small>
          </p-panel>
        </div>

        <div class="col-span-12 xl:col-span-7">
          <p-panel [header]="'EmployeeAccount_Section_Accounts' | translateWF: 'Accounts'">
            <form [formGroup]="form" class="flex flex-col gap-5">
              <div class="form-box">
                <app-financial-account-select
                  [label]="fieldLabels.advanceGlAccountReference | translateWF: 'Employee advances account'"
                  [referenceControl]="form.controls.advanceGlAccountReference"
                  [numberControl]="advanceNumberControl"
                  [nameControl]="advanceNameControl"
                  [subledgerType]="subledgerEmployee"
                  [postingModule]="pettyCash"
                  [postingOnly]="true"
                  [required]="true"
                  [readonly]="!canEdit"
                />
              </div>
              <div class="form-box">
                <app-financial-account-select
                  [label]="fieldLabels.apGlAccountReference | translateWF: 'Payable to employee account'"
                  [referenceControl]="form.controls.apGlAccountReference"
                  [numberControl]="apNumberControl"
                  [nameControl]="apNameControl"
                  [subledgerType]="subledgerEmployee"
                  [postingModule]="pettyCash"
                  [postingOnly]="true"
                  [required]="true"
                  [readonly]="!canEdit"
                />
              </div>
              <div class="form-box-row">
                <p-toggleswitch inputId="employee-active" formControlName="isActive" />
                <label for="employee-active">{{ fieldLabels.isActive | translateWF: 'Active (can take new trips and advances)' }}</label>
              </div>
              <small class="text-surface-500">
                {{
                  'EmployeeAccount_Section_Accounts_Hint'
                    | translateWF
                      : 'Only accounts on the Employee subledger that authorize Petty Cash can be chosen. Trips and advances post to the accounts set here when they are posted.'
                }}
              </small>
            </form>
          </p-panel>
        </div>
      </div>
    }
  </div>
</main>
